document.querySelectorAll('.letter-section').forEach(function (element, index) {
    if (!element.querySelector('.brands-wrapp *')) {
        element.remove()
    }
    var brands = [];
    element.querySelectorAll('a[data-brand]').forEach(function (element) {
        if (!brands.includes(element.dataset.brand)) {
            brands.push(element.dataset.brand);
        } else {
            element.remove();
        }
    });
});
